webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(229);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(363);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Home = __webpack_require__(365);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Tracking = __webpack_require__(369);
	
	var _Tracking2 = _interopRequireDefault(_Tracking);
	
	var _LogTime = __webpack_require__(366);
	
	var _LogTime2 = _interopRequireDefault(_LogTime);
	
	var _Gallery = __webpack_require__(364);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Login = __webpack_require__(367);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _vueRouter = __webpack_require__(378);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(377);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
		routes: [{ path: '/', component: _Home2.default }, { path: '/home', component: _Home2.default }, { path: '/tracking', component: _Tracking2.default,
			children: [{
				path: 'log-time',
				component: _LogTime2.default
			}]
		}, { path: '/gallery', component: _Gallery2.default }, { path: '/login', component: _Login2.default }, { path: '*', redirect: '/home' }],
		mode: 'history'
	});
	
	var bus = new _vue2.default({});
	
	var app = new _vue2.default({
		router: router,
		data: {
			bus: bus
		},
		render: function render(h) {
			return h(_App2.default);
		}
	}).$mount('#app');

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	"use strict";

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(310);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _store = __webpack_require__(309);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      timeEntry: {
	        user: {
	          firstName: 'Ryan',
	          lastName: 'Chenkie',
	          email: 'ryanchenkie@gmail.com',
	          image: 'https://1.gravatar.com/avatar/7f4ec37467f2f7db6fffc7b4d2cc8dc2?s=250&d=retro&r=g'
	        }
	      }
	    };
	  },
	
	  methods: {
	    save: function save() {
	      var timeEntry = this.timeEntry;
	
	      if ((0, _keys2.default)(timeEntry).length > 1) {
	        _store2.default.commit('timeUpdate', timeEntry);
	      }
	
	      this.timeEntry = {
	        user: {
	          firstName: 'Eskie Sirius',
	          lastName: 'Maquilang',
	          email: 'eskiesiriusmaquilang@gmail.com',
	          image: 'https://s.gravatar.com/avatar/f8ffe384215d64694c4dfb263737ea39?s=80'
	        }
	      };
	    }
	  }
	};

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

	"use strict";

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['time']
	};

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(312);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _promise = __webpack_require__(61);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(311);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _Sidebar = __webpack_require__(368);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _database = __webpack_require__(308);
	
	var database = _interopRequireWildcard(_database);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	    components: { 'sidebar': _Sidebar2.default },
	
	    data: function data() {
	        return {
	            zip: "",
	            lat: "",
	            long: "",
	
	            prediction: "8:30",
	            progressIncrement: 0,
	            progressAccumulation: 0,
	            progressTotal: 0,
	            pDeerGivenDayTime: 5,
	            pDeerGivenTime: 5
	        };
	    },
	
	    watch: {
	        progressAccumulation: function progressAccumulation() {
	            document.querySelector('#myBar').style.width = this.progressAccumulation + '%';
	            document.querySelector('#myProgress').style.opacity = 1.0;
	        },
	
	        pDeerGivenDayTime: function pDeerGivenDayTime() {
	            document.querySelector('.deer-given-day-time').innerHTML = '<strong>Probability of Deer Given Daytime</strong> <div>' + this.pDeerGivenDayTime + '</div>';
	        },
	
	        pDeerGivenTime: function pDeerGivenTime() {
	            document.querySelector('.deer-given-time').innerHTML = '<strong>Probability of Deer Given Time</strong> <div>' + this.pDeerGivenTime + '</div>';
	        }
	    },
	
	    methods: {
	        getFileData: function getFileData(e) {
	            var _this = this;
	
	            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	                var allFiles, fileDate, FIPS, timeout, year, month, day, dayOfYear, hour, minute, startDate, endDate, imageID, imageCount, averageHighTemp, averageLowTemp, _i, start, diff, oneDay, earliestFileDate, latestFileDate, diffTime, diffDays, temperaturePromises, firestorePromises, temperatures, wait, _i2, _i3, time, good, test, selectedDay, selectedMonth, selectedTime, selectedHighTemp, selectedLowTemp, _i4, i, sightingsTime, sightingsDay, sightingsHighTemp, sightingsLowTemp, _i5, pDeer, pTimeGivenDeer, pDayGivenDeer, pHighTemp, pLowTemp, pHighTempGivenDeer, pLowTempGivenDeer, pHighTempGivenDay, pLowTempGivenDay, pDeerGivenHighTemp, pDeerGivenLowTemp, pDeerGivenHighTempDayTime, pDeerGivenLowTempDayTime;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                allFiles = document.querySelector('.files').files;
	                                fileDate = void 0;
	                                FIPS = void 0;
	                                timeout = 0;
	
	                                _this.progressIncrement = allFiles.length * .01;
	                                _this.progressTotal = _this.progressIncrement;
	
	                                year = [];
	                                month = [];
	                                day = [];
	                                dayOfYear = [];
	                                hour = [];
	                                minute = [];
	                                startDate = [];
	                                endDate = [];
	                                imageID = [];
	                                imageCount = 0;
	                                averageHighTemp = [23, 29, 42, 57, 69, 78, 82, 79, 72, 60, 43, 28];
	                                averageLowTemp = [6, 12, 23, 36, 47, 57, 61, 59, 50, 39, 26, 12];
	
	                                if (!(allFiles !== null)) {
	                                    _context.next = 88;
	                                    break;
	                                }
	
	                                for (_i = 0; _i < allFiles.length; _i++) {
	                                    fileDate = allFiles.item(_i).lastModifiedDate;
	                                    year.push(fileDate.getFullYear());
	                                    month.push(fileDate.getMonth() + 1);
	                                    day.push(fileDate.getDate());
	                                    hour.push(fileDate.getHours());
	                                    minute.push(fileDate.getMinutes());
	                                    imageID.push(imageCount++);
	
	                                    month[_i] < 10 ? month[_i] = '0' + month[_i] : month[_i];
	                                    day[_i] < 10 ? day[_i] = '0' + day[_i] : day[_i];
	                                    startDate.push(year[_i] + '-' + month[_i] + '-' + day[_i]);
	                                    endDate.push(year[_i] + '-' + month[_i] + '-' + day[_i]);
	
	                                    start = new Date(fileDate.getFullYear(), 0, 0);
	                                    diff = fileDate - start + (start.getTimezoneOffset() - fileDate.getTimezoneOffset()) * 60 * 1000;
	                                    oneDay = 1000 * 60 * 60 * 24;
	
	                                    dayOfYear.push(Math.floor(diff / oneDay));
	                                }
	
	                                earliestFileDate = allFiles.item(0).lastModifiedDate;
	                                latestFileDate = allFiles.item(allFiles.length - 1).lastModifiedDate;
	                                diffTime = Math.abs(latestFileDate.getTime() - earliestFileDate.getTime());
	                                diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
	                                temperaturePromises = [];
	                                firestorePromises = [];
	                                temperatures = [];
	
	                                wait = function wait(timeout) {
	                                    return new _promise2.default(function (resolve, reject) {
	                                        return setTimeout(resolve, timeout);
	                                    });
	                                };
	
	                                _i2 = 0;
	
	                            case 29:
	                                if (!(_i2 < allFiles.length)) {
	                                    _context.next = 37;
	                                    break;
	                                }
	
	                                temperaturePromises.push(database.getTemperature(_this.zip, startDate[_i2], endDate[_i2], 'GHCND'));
	                                _context.next = 33;
	                                return wait(300);
	
	                            case 33:
	                                if (_this.progressAccumulation != 100) {
	                                    if (_i2 == allFiles.length - 1) {
	                                        _this.progressAccumulation = 100;
	                                    } else {
	                                        while (_i2 + 1 > _this.progressTotal) {
	                                            _this.progressAccumulation += 1;
	                                            _this.progressTotal += _this.progressIncrement;
	                                        }
	                                    }
	                                }
	
	                            case 34:
	                                _i2++;
	                                _context.next = 29;
	                                break;
	
	                            case 37:
	                                _context.next = 39;
	                                return _promise2.default.all(temperaturePromises).then(function (temp) {
	                                    temperatures = temp;
	                                });
	
	                            case 39:
	
	                                for (_i3 = 0; _i3 < allFiles.length; _i3++) {
	                                    firestorePromises.push(database.uploadToFirestore(year[_i3], month[_i3], day[_i3], hour[_i3], minute[_i3], imageID[_i3], temperatures[_i3][0], temperatures[_i3][1], dayOfYear[_i3]));
	                                }
	
	                                _context.next = 42;
	                                return _promise2.default.all(firestorePromises);
	
	                            case 42:
	                                time = [];
	                                good = [];
	                                test = [];
	                                selectedDay = 207;
	                                selectedMonth = 9;
	                                selectedTime = 14;
	                                selectedHighTemp = 80;
	                                selectedLowTemp = 51;
	
	
	                                for (_i4 = 0; _i4 < allFiles.length; _i4++) {
	                                    time[_i4] = 2 * hour[_i4] + Math.round(minute[_i4] / 30);
	
	                                    if (time[_i4] == 48) {
	                                        time[_i4] = 0;
	                                    }
	                                }
	                                i = 0;
	
	                            case 52:
	                                if (!(i < imageCount - 1)) {
	                                    _context.next = 66;
	                                    break;
	                                }
	
	                                test = [day[i], time[i]];
	                                good.push(i);
	                                i = i + 1;
	
	                                if (!(i == imageCount - 2)) {
	                                    _context.next = 58;
	                                    break;
	                                }
	
	                                return _context.abrupt('break', 66);
	
	                            case 58:
	                                if (!(test[0] == day[i + 1] && test[1] == time[i + 1])) {
	                                    _context.next = 64;
	                                    break;
	                                }
	
	                                i = i + 1;
	
	                                if (!(i == imageCount - 2)) {
	                                    _context.next = 62;
	                                    break;
	                                }
	
	                                return _context.abrupt('break', 64);
	
	                            case 62:
	                                _context.next = 58;
	                                break;
	
	                            case 64:
	                                _context.next = 52;
	                                break;
	
	                            case 66:
	                                sightingsTime = new Array(48).fill(0);
	                                sightingsDay = new Array(365).fill(0);
	                                sightingsHighTemp = new Array(120).fill(0);
	                                sightingsLowTemp = new Array(120).fill(0);
	
	
	                                for (_i5 = 0; _i5 < good.length; _i5++) {
	                                    sightingsTime[time[good[_i5]]] = sightingsTime[time[good[_i5]]] + 1;
	                                    sightingsDay[dayOfYear[good[_i5]]] = sightingsDay[dayOfYear[good[_i5]]] + 1;
	                                    sightingsHighTemp[temperatures[good[_i5]][1]] = sightingsHighTemp[temperatures[good[_i5]][1]] + 1;
	                                    sightingsLowTemp[temperatures[good[_i5]][0]] = sightingsLowTemp[temperatures[good[_i5]][0]] + 1;
	                                }
	
	                                pDeer = good.length / (diffDays * 48);
	                                pTimeGivenDeer = sightingsTime[selectedTime] / good.length;
	
	                                _this.pDeerGivenTime = .71;
	                                pDayGivenDeer = sightingsDay[selectedDay] / good.length;
	
	                                _this.pDeerGivenDayTime = .60;
	
	                                pHighTemp = Math.exp(-Math.pow(selectedHighTemp - 55.3, 2) / 200) / Math.sqrt(200 * Math.PI);
	                                pLowTemp = Math.exp(-Math.pow(selectedLowTemp - 35.6, 2) / 200) / Math.sqrt(200 * Math.PI);
	                                pHighTempGivenDeer = sightingsHighTemp[selectedHighTemp] / good.length;
	                                pLowTempGivenDeer = sightingsLowTemp[selectedLowTemp] / good.length;
	                                pHighTempGivenDay = Math.exp(-Math.pow(selectedHighTemp - averageHighTemp[selectedMonth - 1], 2) / 200) / Math.sqrt(200 * Math.PI);
	                                pLowTempGivenDay = Math.exp(-Math.pow(selectedLowTemp - averageLowTemp[selectedMonth - 1], 2) / 200) / Math.sqrt(200 * Math.PI);
	                                pDeerGivenHighTemp = pDeer * pHighTempGivenDeer / pHighTemp;
	                                pDeerGivenLowTemp = pDeer * pLowTempGivenDeer / pLowTemp;
	                                pDeerGivenHighTempDayTime = pDeer * pHighTempGivenDeer * pDayGivenDeer * pTimeGivenDeer * 365.25 * 48 / pHighTempGivenDay;
	                                pDeerGivenLowTempDayTime = pDeer * pLowTempGivenDeer * pDayGivenDeer * pTimeGivenDeer * 365.25 * 48 / pLowTempGivenDay;
	
	                                console.log("pDeerGivenTime: " + _this.pDeerGivenTime);
	                                console.log("pDeerGivenDayTime: " + _this.pDeerGivenDayTime);
	
	                            case 88:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this);
	            }))();
	        }
	    }
	};

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(61);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.uploadToFirebase = uploadToFirebase;
	exports.uploadToFirestore = uploadToFirestore;
	exports.getTemperature = getTemperature;
	exports.latLong2Fips = latLong2Fips;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var firebase = __webpack_require__(354);
	__webpack_require__(355);
	__webpack_require__(356);
	
	var config = {
	    apiKey: "AIzaSyBQlZUJK5wRvpOKFINaMWGT9jJeTLTgP78",
	    authDomain: "predictive-deer-tracker.firebaseapp.com",
	    databaseURL: "https://predictive-deer-tracker.firebaseio.com",
	    projectId: "predictive-deer-tracker",
	    storageBucket: "predictive-deer-tracker.appspot.com",
	    messagingSenderId: "473245916948"
	};
	firebase.initializeApp(config);
	
	var firestore = firebase.firestore();
	var database = firebase.database();
	var updates = {};
	
	function uploadToFirebase(year, month, day, hour, minute, lowTemp, highTemp) {
	    updates['/year'] = year;
	    updates['/month'] = month;
	    updates['/day'] = day;
	    updates['/hour'] = hour;
	    updates['/minute'] = minute;
	    updates['/lowTemp'] = lowTemp;
	    updates['/highTemp'] = highTemp;
	
	    return database.ref().update(updates);
	}
	
	function uploadToFirestore(year, month, day, hour, minute, imageID, lowTemp, highTemp, dayOfYear) {
	    firestore.collection('/user/1/images').doc('' + imageID).set({
	        year: year,
	        month: month,
	        day: day,
	        hour: hour,
	        minute: minute,
	        lowTemp: lowTemp,
	        highTemp: highTemp,
	        dayOfYear: dayOfYear
	    }).then(function () {}).catch(function (error) {
	        console.log("Error adding document: ", error);
	    });
	}
	
	function getTemperature(zip, startDate, endDate, dataset) {
	    return new _promise2.default(function (resolve, reject) {
	        var apiKey = 'suKlQEiyzoZuQufBYvwuTWksOpgvLyhI';
	        var params = 'datasetid=' + dataset + '&datatypeid=TMIN&datatypeid=TMAX&locationid=ZIP:' + zip + '&startdate=' + startDate + '&enddate=' + endDate + '&limit=5&units=standard';
	        var request = new XMLHttpRequest();
	        var temperature = {};
	
	        request.open('GET', 'https://www.ncdc.noaa.gov/cdo-web/api/v2/data?' + params, true);
	
	        request.setRequestHeader("token", apiKey);
	
	        request.onload = function () {
	            var data = JSON.parse(this.response);
	
	            if (request.status >= 200 && request.status < 400) {
	                if (data.results == undefined) {
	                    temperature[0] = null;
	                    temperature[1] = null;
	                } else {
	                    for (var i = 0; i < data.results.length; i++) {
	                        if (data.results[i].datatype == 'TMIN') {
	                            temperature[0] = data.results[i].value;
	                        }
	                        if (data.results[i].datatype == 'TMAX') {
	                            temperature[1] = data.results[i].value;
	                        }
	                    }
	                }
	            } else {
	                console.log('error, setting TMAX & TMINs to null');
	                temperature[0] = null;
	                temperature[1] = null;
	            }
	            resolve(temperature);
	        };
	
	        request.send();
	    });
	}
	
	function latLong2Fips(lat, long) {
	    var request = new XMLHttpRequest();
	
	    request.open('GET', 'https://geo.fcc.gov/api/census/area?lat=' + lat + '&lon=' + long + '&format=json', true);
	
	    request.onload = function () {
	        var data = JSON.parse(this.response);
	
	        if (request.status >= 200 && request.status < 400) {
	            return data.results[0].county_fips;
	        } else {
	            console.log('error');
	        }
	    };
	    request.send();
	}

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(380);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vue = __webpack_require__(229);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
	  state: {
	    timeEntries: [],
	    totalTime: 0
	  },
	  mutations: {
	    timeUpdate: function timeUpdate(state, timeEntry) {
	      state.totalTime += Number(timeEntry.totalTime);
	      state.timeEntries.push(timeEntry);
	    },
	    deleteTime: function deleteTime(state, timeEntry) {
	      var index = state.timeEntries.indexOf(timeEntry);
	      state.timeEntries.splice(index, 1);
	      state.totalTime -= timeEntry.totalTime;
	    }
	  }
	});
	
	exports.default = store;

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 351:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 352:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 100,
		"./af.js": 100,
		"./ar": 107,
		"./ar-dz": 101,
		"./ar-dz.js": 101,
		"./ar-kw": 102,
		"./ar-kw.js": 102,
		"./ar-ly": 103,
		"./ar-ly.js": 103,
		"./ar-ma": 104,
		"./ar-ma.js": 104,
		"./ar-sa": 105,
		"./ar-sa.js": 105,
		"./ar-tn": 106,
		"./ar-tn.js": 106,
		"./ar.js": 107,
		"./az": 108,
		"./az.js": 108,
		"./be": 109,
		"./be.js": 109,
		"./bg": 110,
		"./bg.js": 110,
		"./bm": 111,
		"./bm.js": 111,
		"./bn": 112,
		"./bn.js": 112,
		"./bo": 113,
		"./bo.js": 113,
		"./br": 114,
		"./br.js": 114,
		"./bs": 115,
		"./bs.js": 115,
		"./ca": 116,
		"./ca.js": 116,
		"./cs": 117,
		"./cs.js": 117,
		"./cv": 118,
		"./cv.js": 118,
		"./cy": 119,
		"./cy.js": 119,
		"./da": 120,
		"./da.js": 120,
		"./de": 123,
		"./de-at": 121,
		"./de-at.js": 121,
		"./de-ch": 122,
		"./de-ch.js": 122,
		"./de.js": 123,
		"./dv": 124,
		"./dv.js": 124,
		"./el": 125,
		"./el.js": 125,
		"./en-SG": 126,
		"./en-SG.js": 126,
		"./en-au": 127,
		"./en-au.js": 127,
		"./en-ca": 128,
		"./en-ca.js": 128,
		"./en-gb": 129,
		"./en-gb.js": 129,
		"./en-ie": 130,
		"./en-ie.js": 130,
		"./en-il": 131,
		"./en-il.js": 131,
		"./en-nz": 132,
		"./en-nz.js": 132,
		"./eo": 133,
		"./eo.js": 133,
		"./es": 136,
		"./es-do": 134,
		"./es-do.js": 134,
		"./es-us": 135,
		"./es-us.js": 135,
		"./es.js": 136,
		"./et": 137,
		"./et.js": 137,
		"./eu": 138,
		"./eu.js": 138,
		"./fa": 139,
		"./fa.js": 139,
		"./fi": 140,
		"./fi.js": 140,
		"./fo": 141,
		"./fo.js": 141,
		"./fr": 144,
		"./fr-ca": 142,
		"./fr-ca.js": 142,
		"./fr-ch": 143,
		"./fr-ch.js": 143,
		"./fr.js": 144,
		"./fy": 145,
		"./fy.js": 145,
		"./ga": 146,
		"./ga.js": 146,
		"./gd": 147,
		"./gd.js": 147,
		"./gl": 148,
		"./gl.js": 148,
		"./gom-latn": 149,
		"./gom-latn.js": 149,
		"./gu": 150,
		"./gu.js": 150,
		"./he": 151,
		"./he.js": 151,
		"./hi": 152,
		"./hi.js": 152,
		"./hr": 153,
		"./hr.js": 153,
		"./hu": 154,
		"./hu.js": 154,
		"./hy-am": 155,
		"./hy-am.js": 155,
		"./id": 156,
		"./id.js": 156,
		"./is": 157,
		"./is.js": 157,
		"./it": 159,
		"./it-ch": 158,
		"./it-ch.js": 158,
		"./it.js": 159,
		"./ja": 160,
		"./ja.js": 160,
		"./jv": 161,
		"./jv.js": 161,
		"./ka": 162,
		"./ka.js": 162,
		"./kk": 163,
		"./kk.js": 163,
		"./km": 164,
		"./km.js": 164,
		"./kn": 165,
		"./kn.js": 165,
		"./ko": 166,
		"./ko.js": 166,
		"./ku": 167,
		"./ku.js": 167,
		"./ky": 168,
		"./ky.js": 168,
		"./lb": 169,
		"./lb.js": 169,
		"./lo": 170,
		"./lo.js": 170,
		"./lt": 171,
		"./lt.js": 171,
		"./lv": 172,
		"./lv.js": 172,
		"./me": 173,
		"./me.js": 173,
		"./mi": 174,
		"./mi.js": 174,
		"./mk": 175,
		"./mk.js": 175,
		"./ml": 176,
		"./ml.js": 176,
		"./mn": 177,
		"./mn.js": 177,
		"./mr": 178,
		"./mr.js": 178,
		"./ms": 180,
		"./ms-my": 179,
		"./ms-my.js": 179,
		"./ms.js": 180,
		"./mt": 181,
		"./mt.js": 181,
		"./my": 182,
		"./my.js": 182,
		"./nb": 183,
		"./nb.js": 183,
		"./ne": 184,
		"./ne.js": 184,
		"./nl": 186,
		"./nl-be": 185,
		"./nl-be.js": 185,
		"./nl.js": 186,
		"./nn": 187,
		"./nn.js": 187,
		"./pa-in": 188,
		"./pa-in.js": 188,
		"./pl": 189,
		"./pl.js": 189,
		"./pt": 191,
		"./pt-br": 190,
		"./pt-br.js": 190,
		"./pt.js": 191,
		"./ro": 192,
		"./ro.js": 192,
		"./ru": 193,
		"./ru.js": 193,
		"./sd": 194,
		"./sd.js": 194,
		"./se": 195,
		"./se.js": 195,
		"./si": 196,
		"./si.js": 196,
		"./sk": 197,
		"./sk.js": 197,
		"./sl": 198,
		"./sl.js": 198,
		"./sq": 199,
		"./sq.js": 199,
		"./sr": 201,
		"./sr-cyrl": 200,
		"./sr-cyrl.js": 200,
		"./sr.js": 201,
		"./ss": 202,
		"./ss.js": 202,
		"./sv": 203,
		"./sv.js": 203,
		"./sw": 204,
		"./sw.js": 204,
		"./ta": 205,
		"./ta.js": 205,
		"./te": 206,
		"./te.js": 206,
		"./tet": 207,
		"./tet.js": 207,
		"./tg": 208,
		"./tg.js": 208,
		"./th": 209,
		"./th.js": 209,
		"./tl-ph": 210,
		"./tl-ph.js": 210,
		"./tlh": 211,
		"./tlh.js": 211,
		"./tr": 212,
		"./tr.js": 212,
		"./tzl": 213,
		"./tzl.js": 213,
		"./tzm": 215,
		"./tzm-latn": 214,
		"./tzm-latn.js": 214,
		"./tzm.js": 215,
		"./ug-cn": 216,
		"./ug-cn.js": 216,
		"./uk": 217,
		"./uk.js": 217,
		"./ur": 218,
		"./ur.js": 218,
		"./uz": 220,
		"./uz-latn": 219,
		"./uz-latn.js": 219,
		"./uz.js": 220,
		"./vi": 221,
		"./vi.js": 221,
		"./x-pseudo": 222,
		"./x-pseudo.js": 222,
		"./yo": 223,
		"./yo.js": 223,
		"./zh-cn": 224,
		"./zh-cn.js": 224,
		"./zh-hk": 225,
		"./zh-hk.js": 225,
		"./zh-tw": 226,
		"./zh-tw.js": 226
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 357;


/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/deer_logo_svg.88ec511.svg";

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(351)
	
	var Component = __webpack_require__(16)(
	  /* script */
	  __webpack_require__(302),
	  /* template */
	  __webpack_require__(373),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(16)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(371),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(350)
	
	var Component = __webpack_require__(16)(
	  /* script */
	  __webpack_require__(303),
	  /* template */
	  __webpack_require__(372),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(16)(
	  /* script */
	  __webpack_require__(304),
	  /* template */
	  __webpack_require__(375),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(349)
	
	var Component = __webpack_require__(16)(
	  /* script */
	  __webpack_require__(305),
	  /* template */
	  __webpack_require__(370),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(353)
	
	var Component = __webpack_require__(16)(
	  /* script */
	  __webpack_require__(306),
	  /* template */
	  __webpack_require__(376),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(352)
	
	var Component = __webpack_require__(16)(
	  /* script */
	  __webpack_require__(307),
	  /* template */
	  __webpack_require__(374),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 370:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper gallery-wrapper"
	  }, [_c('div', {
	    staticClass: "jumbotron jumbotron-fluid"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('h1', {
	    staticClass: "display-4"
	  }, [_vm._v("Coming Soon!")]), _vm._v(" "), _c('p', {
	    staticClass: "lead"
	  }, [_c('strong', [_vm._v("\n          Stay tuned!\n      ")])])])])])
	}]}

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "jumbotron jumbotron-fluid"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('img', {
	    staticClass: "img-fluid center-block",
	    attrs: {
	      "src": __webpack_require__(362),
	      "width": "230px",
	      "height": "230px"
	    }
	  }), _vm._v(" "), _c('h1', {
	    staticClass: "display-4 text-center"
	  }, [_vm._v("Predictive Deer Tracker")]), _vm._v(" "), _c('p', {
	    staticClass: "lead text-center"
	  }, [_c('strong', [_vm._v("\n      Get started by "), _c('a', {
	    attrs: {
	      "href": '/tracking'
	    }
	  }, [_vm._v("uploading your images")]), _vm._v(".\n    ")])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "navbar-expand-md"
	    }
	  }, [_c('nav', {
	    staticClass: "navbar navbar-default"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('a', {
	    staticClass: "navbar-brand",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-tree-conifer"
	  }), _vm._v("\n        Predictive Deer Tracker\n      ")])]), _vm._v(" "), _c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [_c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "tag": "li",
	      "to": "/"
	    }
	  }, [_c('a', [_vm._v("Home")])]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "tag": "li",
	      "to": "/tracking"
	    }
	  }, [_c('a', [_vm._v("Tracking")])]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "tag": "li",
	      "to": "/gallery"
	    }
	  }, [_c('a', [_vm._v("Gallery")])])], 1), _vm._v(" "), _c('ul', {
	    staticClass: "nav navbar-nav navbar-right"
	  }, [_c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "tag": "li",
	      "to": "/login"
	    }
	  }, [_c('a', [_c('span', {
	    staticClass: "glyphicon glyphicon-user"
	  }), _vm._v(" Sign Up")])]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "tag": "li",
	      "to": "/login"
	    }
	  }, [_c('a', [_c('span', {
	    staticClass: "glyphicon glyphicon-log-in"
	  }), _vm._v(" Login")])])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('router-view')], 1)])
	},staticRenderFns: []}

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('sidebar')], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('div', {
	    staticClass: "panel panel-primary"
	  }, [_c('div', {
	    staticClass: "panel-heading text-center header"
	  }, [_vm._v("Prediction Tool")]), _vm._v(" "), _c('div', {
	    staticClass: "panel-body text-center"
	  }, [_c('div', {
	    staticClass: "location-input small-spacer"
	  }, [_vm._m(0), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.zip),
	      expression: "zip"
	    }],
	    staticClass: "text-center",
	    attrs: {
	      "type": "number",
	      "placeholder": "e.g. 52162"
	    },
	    domProps: {
	      "value": (_vm.zip)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.zip = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "button-container"
	  }, [_c('button', {
	    staticClass: "btn-info submit-button",
	    on: {
	      "click": _vm.getFileData
	    }
	  }, [_vm._v("Submit")])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "myProgress"
	    }
	  }, [_c('div', {
	    staticClass: "text-center",
	    attrs: {
	      "id": "myBar"
	    }
	  }, [_vm._v(_vm._s(_vm.progressAccumulation) + "%")])]), _vm._v(" "), _c('div', {
	    staticClass: "progress-text text-center"
	  })])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "text-center small-spacer"
	  }, [_vm._v("Enter ZIP Code pictures were taken in")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "file-input"
	  }, [_c('label', {
	    staticClass: "text-reader"
	  }, [_vm._v("\n                          Select Files\n                          "), _c('input', {
	    staticClass: "files",
	    attrs: {
	      "type": "file",
	      "multiple": ""
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "panel panel-default"
	  }, [_c('div', {
	    staticClass: "panel-heading text-center header-small"
	  }, [_vm._v("Results")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "result-section jumbotron"
	  }, [_c('div', {
	    staticClass: "col-sm-6 text-center deer-given-time"
	  }, [_c('div', {
	    staticClass: "deer-given-time-result"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 text-center deer-given-day-time"
	  }, [_c('div', {
	    staticClass: "deer-given-day-time-result"
	  })])])
	}]}

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.timeEntry.date),
	      expression: "timeEntry.date"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "date",
	      "placeholder": "Date"
	    },
	    domProps: {
	      "value": (_vm.timeEntry.date)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.timeEntry, "date", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('label', [_vm._v("Hours")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.timeEntry.totalTime),
	      expression: "timeEntry.totalTime"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "placeholder": "Hours"
	    },
	    domProps: {
	      "value": (_vm.timeEntry.totalTime)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.timeEntry, "totalTime", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('label', [_vm._v("Comment")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.timeEntry.comment),
	      expression: "timeEntry.comment"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Comment"
	    },
	    domProps: {
	      "value": (_vm.timeEntry.comment)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.timeEntry, "comment", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        return _vm.save()
	      }
	    }
	  }, [_vm._v("Save")]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": '/time-entries/'
	    }
	  }, [_c('a', {
	    staticClass: "btn btn-primary"
	  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('hr')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "panel-group information-group"
	  }, [_c('div', {
	    staticClass: "panel panel-info info-panel"
	  }, [_c('div', {
	    staticClass: "panel-heading header text-center"
	  }, [_vm._v(" Instructions ")]), _vm._v(" "), _c('div', {
	    staticClass: "panel-body"
	  }, [_c('ol', {
	    staticClass: "instructions"
	  }, [_c('li', [_vm._v("Set your ZIP Code to the the location of the images you will be uploading.")]), _vm._v(" "), _c('li', [_vm._v("Click on the "), _c('i', [_vm._v("\"Select Files\"")]), _vm._v(" button to open up your file directory. \n            From there, select every picture you want analyzed. \n            \n        ")]), _vm._v(" "), _c('li', [_vm._v("Hit the "), _c('i', [_vm._v("\"Submit\"")]), _vm._v(" button. Everything will be processed and the progress bar will keep\n            you updated on the status of the analysis!\n        ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "panel-spacer"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "panel panel-info"
	  }, [_c('div', {
	    staticClass: "panel-heading header text-center"
	  }, [_vm._v(" Additional Information ")]), _vm._v(" "), _c('div', {
	    staticClass: "panel-body additional-information"
	  }, [_c('ul', [_c('li', [_c('i', [_vm._v("Helpful Tip:")]), _vm._v(" ctrl + click selects a new file while keeping the previous files selected.\n                                You can also use shift + click as a powerfully similar selection tool.\n        ")]), _vm._v(" "), _c('li', [_vm._v("Expect longer wait times the more files you choose to upload.")]), _vm._v(" "), _c('li', [_vm._v("In very rare circumstances, the zip code you provide may not work. \n            Use a different ZIP!\n        ")])])])])])
	}]}

/***/ }),

/***/ 382:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.ffdc12028b0f282e8654.js